<template>
  <div class="text-xs-center">
    Para mais informações sobre como converter ou reduzir o tamanho do PDF, <b @click="dialog = true"> clique aqui </b>.
    <v-dialog
      persistent
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline text--white green darken-2 text-xs-center" style="color: #fff;">
          Ajuda
        </v-card-title>

        <v-card-text>
          <p>
            Arquivos PDF vindo de impressoras multifuncionais ou scanners costumam apresentar erros ao serem inseridos no sistema.
            Caso você tenha recebido a mensagem "Erro ao processsar Documento PDF. Tente converte-lo antes de enviar novamente", poderá utilizar a ferramenta online
            <a href="https://smallpdf.com/pt/" target="_blank">SmallPDF</a> para realizar essa operação.
          </p>

          <p>A ferramenta <a href="https://smallpdf.com/pt/compressor-de-pdf" target="_blank">SmallPDF</a> também é capaz de reduzir o tamanho do
            arquivo sem perda de qualidade através da função "Comprimir PDF", chegando a reduzir em até 75% o tamanho do arquivo enviado e dessa forma, ficando dentro do limite de 10MB por arquivo enviado.</p>

          <p>
            Para visualizar um vídeo explicativo sobre como gerar os arquivos PDF's no Windows ou Mac, <a href="https://www.youtube.com/watch?v=C5NPimM_I4o" target="_blank">clique aqui</a>
          </p>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
export default {
  name: 'PdfInformationDialog',
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
